import AdministracionLayout from './AdministracionLayout.vue';
import ProductosPage from './productos/ProductosPage.vue'
import ReportesPage from './reportes/ReportesPage.vue';
import UsuariosPage from './usuarios/UsuariosPage.vue';
import MercadosPage from './mercados/MercadosPage.vue';
import MesasPage from './mesas/MesasPage.vue';

export const administracionRoutes = {
  path: 'administracion',
  component: AdministracionLayout,
  children: [
    {
      path: 'productos',
      name: 'Productos',
      component: ProductosPage,
      meta: {
        moduleAccess: 'Administracion',
      },
    },
    {
      path: 'usuarios',
      name: 'Usuarios',
      component: UsuariosPage,
      meta: {
        moduleAccess: 'Administracion',
      },
    },
    {
      path: 'reportes',
      name: 'Reportes',
      component: ReportesPage,
      meta: {
        moduleAccess: 'Administracion',
      },
    },
    {
      path: 'mercados',
      name: 'Mercados',
      component: MercadosPage,
      meta: {
        moduleAccess: 'Administracion',
      },
    },
    {
      path: 'mesas',
      name: 'Mesas',
      component: MesasPage,
      meta: {
        moduleAccess: 'Administracion',
      },
    },
  ],
  meta: {
    moduleAccess: '',
    requireAuth: true,
    title: 'nav_bar.example',
  },
};
